module.exports = __webpack_public_path__ + "media/icons/s-dark-3fc2e35d.svg";